import { useEffect, useRef, useSyncExternalStore } from 'react';
import { reconcileServerConsent } from './reconcile.js';
import { getConsentSnapshot, getServerConsentSnapshot, registerConsentRecorder, subscribeConsent } from './store.js';
/** The current consent snapshot; re-renders on every change. */
export function useCookieConsent() {
    return useSyncExternalStore(subscribeConsent, getConsentSnapshot, getServerConsentSnapshot);
}
/**
 * Keep a signed-in user's server record in step with the browser (BR-11, BR-12). While
 * `identityId` is set, explicit decisions are uploaded and the decisions reconcile once per
 * identity. When it becomes null (signed out) the recorder is removed and the browser decision
 * is left in place (BR-14).
 */
export function useCookieConsentSync(identityId, api) {
    const apiRef = useRef(api);
    apiRef.current = api;
    const reconciledFor = useRef(null);
    useEffect(() => {
        if (!identityId) {
            reconciledFor.current = null;
            registerConsentRecorder(null);
            return;
        }
        registerConsentRecorder((decision) => apiRef.current.putServerConsent({
            analytics: decision.analytics,
            noticeVersion: decision.noticeVersion,
            source: decision.source,
            decidedAt: decision.decidedAt,
        }));
        if (reconciledFor.current !== identityId) {
            reconciledFor.current = identityId;
            void reconcileServerConsent({
                fetchServerConsent: () => apiRef.current.fetchServerConsent(),
                putServerConsent: (body) => apiRef.current.putServerConsent(body),
            });
        }
        return () => registerConsentRecorder(null);
    }, [identityId]);
}
//# sourceMappingURL=useCookieConsent.js.map